/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PopularGenre
 */
export interface PopularGenre {
    /**
     * Genre name
     * @type {string}
     * @memberof PopularGenre
     */
    name: string;
    /**
     * Number of tracks in this genre for the requested time window
     * @type {number}
     * @memberof PopularGenre
     */
    count: number;
}

/**
 * Check if a given object implements the PopularGenre interface.
 */
export function instanceOfPopularGenre(value: object): value is PopularGenre {
    let isInstance = true;
    isInstance = isInstance && "name" in value && value["name"] !== undefined;
    isInstance = isInstance && "count" in value && value["count"] !== undefined;

    return isInstance;
}

export function PopularGenreFromJSON(json: any): PopularGenre {
    return PopularGenreFromJSONTyped(json, false);
}

export function PopularGenreFromJSONTyped(json: any, ignoreDiscriminator: boolean): PopularGenre {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'count': json['count'],
    };
}

export function PopularGenreToJSON(value?: PopularGenre | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'count': value.count,
    };
}

